// Components==============
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Shade from 'components/UI/Shade';
import React from 'react';
import { useLocation } from 'react-router';
import { encodeURL } from 'utilities/encodeURL';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useScrollFreeze } from 'utilities/useScrollFreeze';
import './index.module.scss';
// =========================

const Component = ({ closeModal, image, imageText, children }) => {
    useScrollFreeze();

    const closeUrlModal = useCloseUrlModal();
    const close = closeModal || closeUrlModal;

    return (
        <>
            <div styleName="wrapper">
                <div styleName="closeModal" onClick={close}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
                {image && (
                    <div styleName="relative">
                        <img src={image} alt="modal" />
                        {imageText && <h2>{imageText}</h2>}
                    </div>
                )}
                <div styleName="content">{children}</div>
            </div>
            <Shade onClick={close} />
        </>
    );
};

export default function Modal({
    slug,
    closeModal,
    image,
    imageText,
    children,
    exact,
}) {
    const { pathname } = useLocation();

    if (
        closeModal ||
        (exact
            ? pathname.includes('popup') && pathname === encodeURL(slug)
            : pathname.includes('popup') && pathname.includes(encodeURL(slug)))
    )
        return (
            <Component
                closeModal={closeModal}
                image={image}
                imageText={imageText}
            >
                {children}
            </Component>
        );

    return <></>;
}
